import React, { useEffect, useState } from 'react';
import Particles, { initParticlesEngine } from '@tsparticles/react';
import { loadSlim } from '@tsparticles/slim';
import "../../CSS/particles.css";

// Renders floating ambient particles fixed over the whole viewport.
// position:fixed means it never affects layout or pushes content.
const CardParticles = ({ data }) => {
    const [engineReady, setEngineReady] = useState(false);

    const packageType = data?.package || data?.packageType;
    const isBasic = packageType === 'Basic';

    useEffect(() => {
        if (isBasic) return; // Don't initialise the engine if Basic
        initParticlesEngine(async (engine) => {
            await loadSlim(engine);
        }).then(() => setEngineReady(true));
    }, [isBasic]);

    const particlesOptions = {
        fullScreen: { enable: true },
        fpsLimit: 60,
        interactivity: {
            events: {
                onClick: { enable: false },
                onHover: { enable: false },
            },
        },
        particles: {
            color: { value: data.designCode === "kdrama-001" ? "#e48518ff" : data.themeColour },
            number: {
                value: 135,
                density: { enable: true },
            },
            opacity: {
                value: { min: 0.15, max: 0.55 },
                animation: {
                    enable: true,
                    speed: 0.6,
                    sync: false,
                },
            },
            shape: {
                type: 'circle',
            },
            size: {
                value: { min: 2, max: 5 },
                animation: {
                    enable: true,
                    speed: 1.5,
                    sync: false,
                },
            },
            move: {
                enable: true,
                speed: { min: 0.4, max: 1.2 },
                direction: 'bottom',
                straight: false,
                outModes: { default: 'out' },
                warp: false,
                random: true,
                wobble: {
                    enable: true,
                    distance: 5,
                    speed: { angle: 3 },
                },
            },
        },
        detectRetina: true,
    };

    if (isBasic || !engineReady) return null;

    return (
        <div className="particles">
            <Particles id="card-particles" options={particlesOptions} />
        </div>
    );
};

export default CardParticles;
